import { Button, Icon } from '@gerdau/hefesto';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../components/Commons/SpinnerIcon/styles';
import {
  loadQCFile,
  downloadQCFile
} from '../../../../../../store/ducks/download-area/action';
import { ICustomerQualityCertificateItem } from '../../../../../../store/ducks/download-area/types';
import { IQCFileResponse } from '../../../../../../store/ducks/long-steel-orders/types';
import { sendTagging } from '../../../../../../store/ducks/tagging/actions';
import { getTaggingInformationScreen } from '../../../../../../utils/Tagging';
import { addToast } from '../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../store/ducks/toast/types';
interface IQCDownloadButtonProps {
  qualityCertificateData: ICustomerQualityCertificateItem;
  invoiceNumber: string;
}

export const QCDownloadButton: React.FC<IQCDownloadButtonProps> = ({
  qualityCertificateData,
  invoiceNumber
}) => {
  const dispatch = useDispatch();
  const [alreadyDownload, setAlreadyDownload] = useState(false);

  const { screenName = '' } = getTaggingInformationScreen('download-area');
  const { itemDescription = '' } = getTaggingInformationScreen(
    'certificado-de-qualidade'
  );

  const handleQCDownload = () => {
    dispatch(
      sendTagging({
        screenName: `${screenName}:CertificadoDeQualidade`,
        itemDescription: `${itemDescription}baixar`,
        itemName: `button:baixar`,
        event: 'click'
      })
    );

    if (
      qualityCertificateData.qcState?.qcFileResponse &&
      isValidFile(qualityCertificateData)
    ) {
      downloadFile(
        qualityCertificateData.qcState.qcFileResponse as IQCFileResponse
      );
    } else {
      dispatch(loadQCFile(qualityCertificateData));
    }
  };

  const downloadQCfromUseEffect = () => {
    if (!qualityCertificateData.qcState?.qcFileResponse) {
      return;
    }
    dispatch(downloadQCFile(qualityCertificateData));
    if (isValidFile(qualityCertificateData)) {
      downloadFile(
        qualityCertificateData.qcState.qcFileResponse as IQCFileResponse
      );
    } else {
      dispatch(
        addToast({
          message: `O pedido não possui certificado disponível`,
          type: EToastTypes.WARNING,
          durationInMS: 5000
        })
      );
    }
  };

  useEffect(() => {
    if (
      qualityCertificateData &&
      !qualityCertificateData.qcState?.alreadyDownloaded &&
      qualityCertificateData.qcState?.qcFileResponse &&
      !alreadyDownload
    ) {
      setAlreadyDownload(true);
      downloadQCfromUseEffect();
    }
  });

  const downloadFile = (qcFileResponse: IQCFileResponse) => {
    const dataurl =
      'data:text/plain;base64,' + qcFileResponse.qcFile.qcBase64File;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute('download', `cq-${invoiceNumber}.pdf`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  function isValidFile(qcData: ICustomerQualityCertificateItem): boolean {
    if (
      qcData.qcState?.qcFileResponse?.qcFile.qcBase64File != null &&
      qcData.qcState?.qcFileResponse?.qcFile.qcBase64File !=
        'Certificado não encontrado'
    ) {
      return true;
    }
    return false;
  }

  return (
    <>
      {qualityCertificateData.canDownloadQC &&
      (!alreadyDownload ||
        (alreadyDownload && isValidFile(qualityCertificateData))) ? (
        <Button
          name="exportQualityCertificate"
          onClick={handleQCDownload}
          icon={
            qualityCertificateData.qcState?.loading ? (
              <SpinnerIcon style={{ margin: '0.125rem' }} />
            ) : (
              <Icon option="Download" />
            )
          }
          iconPosition="left"
          variant="tertiary"
          disabled={qualityCertificateData.qcState?.loading}
        >
          {qualityCertificateData.qcState?.loading ? (
            <>Baixando</>
          ) : (
            <>Baixar certificado</>
          )}
        </Button>
      ) : (
        'Indisponível'
      )}
    </>
  );
};
